import styled from 'styled-components';

//game-info game-preview

export const TableContainerDefaultBox = styled.table`
    padding: 0 8px;
    border-radius: 5px;
    background-color: ${props => props.theme.components.lobbyGameInfoPreview.colors.gameInfoTableBackground};
    color: ${props => props.theme.colors.bodyText};
    & tbody {
        border: none;
        background: transparent;
    }

    & td {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 50%;
        padding: 0;
        padding-right: 15px;
        height: 3.5rem;

        border-bottom: 1px solid ${props => props.theme.colors.dividerBottomBorder};
        border-top: 1px solid ${props => props.theme.colors.dividerTopBorder};
    }

    & tr {
        display: flex;
        background-color: transparent;
        height: 30px;
        &:first-child {
          td {
            border-top: none;
          }
        }
        &:last-child {
          td {
            border-bottom: none;
          }
        }
    }
`;